import tw from 'tailwind-styled-components'
import {MoveToBody} from '@components/move-to-body'
import {Padding} from '../design-system/types'
import {TwWndType} from './types'

export const TwMoveToBody = tw(MoveToBody)`
  top-0
`

export const TwWnd = tw.div<TwWndType>`
  relative
  flex
  flex-col
  bg-background-primary
  items-center
  py-32
  rounded-16
  h-[calc(100%-48px)]
  min-h-[420px]
  max-h-[760px]
  w-[calc(100%-48px)]
  min-w-[1024px]
  max-w-[1280px]
`

export const TwWndContent = tw.div<TwWndType>`
  relative
  rounded-8
  bg-background-primary
  overflow-hidden
  h-full
  flex
  flex-col
`

export const TwCnt = tw.div<{$paddings: Padding}>`
  text-sm-regular
  flex-1
  flex
  flex-col
  min-h-0
`

export const TwFooter = tw.div`
  absolute
  bottom-40
  right-0
  shadow-popup
  w-full
  rounded-12
  h-48
  opacity-90

  flex
  items-center
  justify-end
`

export const TwContainer = tw.div`
  isolate
  z-1000
  flex
  flex-col
  justify-center
  items-center
  absolute
  w-screen
  h-screen
  after:content-['']
  after:absolute
  after:top-0
  after:bottom-0
  after:left-0
  after:right-0
  after:bg-[#344054]
  after:opacity-[0.8]
  after:-z-10
`
